module.exports = __webpack_public_path__ + "static/media/ic_zero_brokerage.212a3927.svg";